import Vue from 'vue';

export default {
    name: "SettingsMixin",
    props: {
        loaded: Boolean,
        setting: Object,
    },

    data() {
        return {};
    },

    methods: {
        getComponentName(setting) {
            return setting.component || 'QTextField';
        },

        settingsValueHasChanged(setting) {
            return setting.value != setting.fetchValue;
        },

        settingValueFromString(setting, rawvalue) {
            var value = rawvalue;
            //parse by typing if not default (String)
            if (setting.type == Number) {
                value = this.parseCommaSafeDecimalField(value);
            }
            else if (setting.type == Boolean) {
                value = value?.toLowerCase() === 'true'
            }

            Vue.set(setting, 'value', value);
            Vue.set(setting, 'fetchValue', value);
        },

        settingValueToString(setting, payload) {
            let value = setting.value;
            if (value && setting.type == Number) {
                value = this.parseCommaSafeDecimalField(value);
                value = value.toString();
            }
            else if (setting.type == Boolean) {
                value = value ? 'true' : 'false'
            }
            payload[setting.settingKey] = value ?? '';
        },

        isSettingValid(setting) {
            if (!setting.rules || !setting.rules.length) {
                return true;
            }

            // A Vuetify-style rule returns `true` if valid, or a string if invalid
            return setting.rules.every(rule => rule(setting.value) === true);
        },

        settingIsClearable(setting) {
            var r = Object.assign([], setting.rules);
            var bool = !r?.some(x => x.name == 'requiredRule');
            //console.log('settingIsClearable', setting.settingKey, bool)
            return bool;
        },
    },

    computed: {},

    watch: {},
};